<template>
	<section class="reg-container" v-loading="loading">
    <el-form ref="regForm" :model="regForm" :rules="regRules"
        class="reg-form"> 
      <div class="reg-Title row1">
        <img class="logo" src="../assets/icon/ic_soc.png" alt="S">
        Group E-learning
      </div>
      <div class="reg-Title row2">
        註冊帳號
      </div>
      <el-form-item prop="name">
        <el-input type="text" 
              v-model="regForm.name" 
              auto-complete="off" 
              placeholder="請輸入姓名">
        </el-input>
      </el-form-item>
      <el-form-item prop="id">
        <el-input type="text" 
              v-model="regForm.id" 
              auto-complete="off" 
              placeholder="請輸入工號">
        </el-input>
      </el-form-item>
      <el-form-item prop="email">
        <el-input type="text" 
              v-model="regForm.email" 
              auto-complete="off" 
              placeholder="請輸入Email">
        </el-input>
      </el-form-item>
      <el-form-item prop="dep">
        <el-cascader class="filter-select" placeholder="請選擇部門"
                v-model="filter.actualDeps.selected" :show-all-levels="false"
                :options="filter.actualDeps.options" @change="actualDepsSelect">
        </el-cascader>
      </el-form-item>
      <el-form-item prop="level">
        <el-select  class="filter-select" placeholder="請選擇師級" 
                v-model="filter.level.selected" @change="levelSelect">
						<el-option v-for="selectedFilter in filter.level.selectedFilters" 
												:key="selectedFilter.value" 
												:label="selectedFilter.text" 
												:value="selectedFilter.value">{{ selectedFilter.text }}</el-option>
					</el-select>
      </el-form-item>
      <el-form-item prop="pwd">
        <el-input :type="showPass ? 'text' : 'password'" 
                  v-model="regForm.pwd" 
                  auto-complete="off" 
                  placeholder="請輸入密碼">
        </el-input>
        <img :title="showPass? '顯示密碼': '隱藏密碼'" 
              @click="showPass=!showPass" 
              style="position: absolute; width: 20px; height: 20px; right: 1rem; top: 0.5rem; cursor: pointer;"
              :src="showPass?openeye:nopeneye">
      </el-form-item>
       <el-form-item prop="pwd2">
        <el-input :type="showPass2 ? 'text' : 'password'" 
                  v-model="regForm.pwd2" 
                  auto-complete="off" 
                  placeholder="請再次輸入密碼">
        </el-input>
        <img :title="showPass2? '顯示密碼': '隱藏密碼'" 
              @click="showPass2=!showPass2" 
              style="position: absolute; width: 20px; height: 20px; right: 1rem; top: 0.5rem; cursor: pointer;"
              :src="showPass2?openeye:nopeneye">
      </el-form-item>
      <el-form-item>
        <el-button type="primary" style="width:100%" @click="register">
            送出申請
        </el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
  import API from '@/api/api';  
  import { DepartmentModel } from '@/common/js/data';
  export default {
    name: 'Register',
    data() {
      var validatePwd = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('請輸入密碼'));
        } else {
          if (this.regForm.pwd2 !== '') {
            this.$refs.regForm.validateField('pwd2');
          }
          callback();
        }
      };
      var validatePwd2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('請再次輸入密碼'));
        } else if (value !== this.regForm.pwd) {
          callback(new Error('兩次輸入密碼不一致!'));
        } else {
          callback();
        }
      };
      return {
        loading: false,
        openeye: require('@/assets/icon/ic_eye.png'), 
        nopeneye: require('@/assets/icon/ic_remove_eye.png'),
        regForm: {
            name: '',
            id: '',
            email: '',
            dep: null,
            level: null,
            pwd: '',
            pwd2: '',
        },
        regRules: {
            name: [
              { required: true, message: '請輸入姓名', trigger: 'blur' },
            ],
            id: [
              { required: true, message: '請輸入工號', trigger: 'blur' },
            ],
            email: [
              { required: true, message: '請輸入Email', trigger: 'blur' },
              { type: 'email', message: '請輸入正確的Email格式', trigger: 'blur'},
            ],
            dep: [
              { required: true, message: '請選擇部門'},
            ],
            level: [
              { required: true, message: '請選擇師級'},
            ],
            pwd: [
              { validator: validatePwd, trigger: 'blur' }
            ],
            pwd2: [
              { validator: validatePwd2, trigger: 'blur' }
            ],
        },
        filter: {
					actualDeps: {
						options: [],
						selected: null,
					},
					level: {
						selectedFilters: [
							{
								value: 1,
								text: 'Level 1 (師2-師5)'
							},
							{
								value: 2,
								text: 'Level 2 (師6-師11)'
							},
							{
								value: 3,
								text: 'Level 3 (師12以上)'
							}
						],
						selected: null,
					},
        },
        showPass: false,
        showPass2: false,
      };
    },
    methods: {
      async init() {
        //actualDep default
        let departmentModel = new DepartmentModel();
        this.filter.actualDeps.options = await departmentModel.getOptions();
      },
      actualDepsSelect(key) {
        if (key.length > 0) {
          this.regForm.dep = key[1];
        }
      },
      levelSelect(key) {
        this.regForm.level = key;
			},
      register() {
        this.$refs.regForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            API.register(this.regForm.name, this.regForm.id, this.regForm.email,
             this.regForm.dep, this.regForm.level, this.regForm.pwd).then((response) => {
              if(response.status) {
                if(!JSON.parse(response.request.response).error_msg) {
                  if (JSON.parse(response.request.response).error_code=== "ERROR_SCIENCE_REGISTER_EXIST") {
                    this.$alert('請等待部門管理員進行審核', '此帳號申請審核中', {
                      confirmButtonText: '確定',
                      type: 'info'
                    });
                  } else {
                    this.$message.error('帳號註冊發生錯誤');
                  }
                } else {
                  this.$message.error(JSON.parse(response.request.response).error_msg);
                }
              } else {
                this.$alert('請等待部門管理員進行審核', '註冊帳號申請已送出', {
                  confirmButtonText: '確定',
                  type: 'success'
                });
              }
              this.loading = false;
            });
            
          } else {
            return false;
          }
        });
      },
    },
    created() {
      this.init();
    },
  }
</script>
<style lang="scss" scoped>
.reg-container {
  height: 100vh;
  overflow-y: hidden;
  background-color: #1D2327;

  .reg-form {
      margin: 100px auto;
      width: 380px;

      .reg-Title {
          color: #FFFFFF;
          text-align: center;
      }

      .row1 {
        font-size: 22px;
        font-weight: 600;
        height: 48px;
        line-height: 48px;

        .logo {
          height: 28px;
          position: relative;
          top: 5px;
          left: 8px;
        }
      }

      .row2 {
        margin-top: 20px;
        margin-bottom: 50px;
        font-size: 24px;
      }

      .filter-select {
        width: 100%;
      }
  }
}

</style>


// WEBPACK FOOTER //
// Register.vue?941c8e2e